export default "__VITE_ASSET__f447a6db__"